export function clearSessionStorage() {
  sessionStorage.removeItem('approvalUrl');
  sessionStorage.removeItem('insuranceStartDate');
  sessionStorage.removeItem('mode');
  sessionStorage.removeItem('paymentId');
  sessionStorage.removeItem('timestamp');
}
